<template>
  <v-row>
    <v-col>
      <data-table :tableData="tableData" :disablePagination="true">
        <template v-slot:[`item.startDate`]="{ item }">
          {{ moment(item.startDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">
          {{ moment(item.endDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.registrationStartDate`]="{ item }">
          {{ moment(item.registrationStartDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.registrationEndDate`]="{ item }">
          {{ moment(item.registrationEndDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.Actions`]="{ item }">
          <v-btn size="small" color="primary" @click="openMiqaat(item.miqaatId)">Open</v-btn>
        </template>
      </data-table>
    </v-col>
  </v-row>
</template>

<script setup>
import { reactive, inject, onMounted } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import { getAvailableForIncharge } from "@/services/miqaatService";

const router = useRouter();
const loader = inject("loader");
const snackbar = inject("snackBar");

const tableData = reactive({
  headers: [
    { title: "Miqaat Name", key: "miqaatName" },
    { title: "Event Start", key: "startDate" },
    { title: "Event End", key: "endDate" },
    { title: "Reg. Start", key: "registrationStartDate" },
    { title: "Reg. End", key: "registrationEndDate" },
    { title: "Registration Amount", key: "registrationCommitmentAmount" },
    { title: "Actions", key: "Actions" },
  ],
  data: [],
});

function openMiqaat(miqaatId) {
  router.push(`/miqaat-management/incharge/${miqaatId}`);
}

async function loadData() {
  loader.show();
  try {
    tableData.data = await getAvailableForIncharge();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

onMounted(loadData);
</script>
